import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import uuidv4 from 'uuid/v4';

import styles from './EventObject.css';
import gameTypeColor from './../../../utils/gameTypeColor';
import { getHM } from './../../../utils/utils';

class EventObject extends Component {
  state = {
    id: uuidv4(),
    isPassed: true,
    hover: false
  };

  componentWillMount() {
    const { event } = this.props;

    return this.setState({ isPassed: new Date() > new Date(event.date_end * 1000) });
  }

  handleToggleHover = () => {
    const { hover } = this.state;

    return this.setState({ hover: !hover });
  }

  renderLineWrapper = content => {
    const { isMobile, event, onShowMobileTooltip } = this.props;
    const { id } = this.state;

    if (isMobile) {
      return (
        <div
          onClick={() => onShowMobileTooltip(this.renderTooltipContent(), event.url)}
          onKeyPress={undefined}
          role="button"
          tabIndex="0"
        >
          {content}
        </div>
      );
    }

    return (
      <a href={event.url} data-tip data-for={id}>
        {content}
      </a>
    );
  }

  renderLine = () => {
    const { event, width } = this.props;


    if (width >= 120) {
      return this.renderLineWrapper((
        <div className={styles.Content}>
          <span>{getHM(event.date_start)}</span>
          <span
            style={{
              margin: '0 0.7rem',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            {event.name}
          </span>
          <span>{getHM(event.date_end)}</span>
        </div>
      ));
    } else if (width >= 82) {
      return this.renderLineWrapper((
        <div className={styles.Content}>
          <span>{getHM(event.date_start)}</span>
          <span>{getHM(event.date_end)}</span>
        </div>
      ));
    }

    return this.renderLineWrapper((
      <div className={styles.Content}>
        <span style={{ whiteSpace: 'nowrap', opacity: 0 }}>
          {event.name}
        </span>
      </div>
    ));
  };

  renderTooltipContent = () => {
    const { event, translations } = this.props;

    return (
      <div className={styles.TooltipText}>
        <p><strong>{`"${event.name}"`}</strong></p>
        <p>{translations['Game type']}: <strong>{event.type.toString()}</strong></p>
        <p>{translations.Polygon}: <strong>{event.polygon.toString()}</strong></p>
        <p>
          <strong>
            {event.country.toString()} {event.region.toString()} {event.city.toString()}
          </strong>
        </p>
        <p>{translations.Organizer}: <strong>{event.org_name.toString()}</strong></p>
        <p>{translations.Start}: <strong>{event.date_start_formatted.toString()}</strong></p>
        <p>{translations.Finish}: <strong>{event.date_end_formatted.toString()}</strong></p>
        <p className={styles.Important}>
          {translations['Ticket price']}: <strong>{event.ticket_price.toString()}</strong>
        </p>
        <p className={styles.Important}>
          {translations['Tickets purchased']}: <strong>{event.tickets_count.toString()}</strong>
        </p>
      </div>
    );
  }

  render() {
    const { style, event } = this.props;
    const { id, isPassed, hover } = this.state;

    return (
      <div
        className={styles.Wrapper}
        style={{
          backgroundColor: gameTypeColor(isPassed && !hover ? undefined : event.type),
          ...style
        }}
        onMouseEnter={this.handleToggleHover}
        onMouseLeave={this.handleToggleHover}
      >
        {this.renderLine()}
        <ReactTooltip place="bottom" type="light" effect="float" id={id}>
          {this.renderTooltipContent()}
        </ReactTooltip>
      </div>
    );
  }
}

EventObject.propTypes = {
  style: PropTypes.shape(),
  event: PropTypes.shape(),
  width: PropTypes.number,
  translations: PropTypes.shape().isRequired,
  isMobile: PropTypes.bool.isRequired,
  onShowMobileTooltip: PropTypes.func.isRequired
};

EventObject.defaultProps = {
  style: {},
  event: {
    name: 'name',
    date_start: '00:00',
    date_end: '00:00',
  },
  width: null
};

export default EventObject;



// WEBPACK FOOTER //
// ./src/components/Events/EventObject/EventObject.js